import { motion } from "framer-motion";

export default function GlobalNetwork() {
  const chapters = [
    { city: "California, USA", members: "1,200+" },
    { city: "London, UK", members: "800+" },
    { city: "Dhaka, Bangladesh", members: "2,500+" },
    { city: "Sydney, Australia", members: "600+" },
    { city: "Dubai, UAE", members: "400+" },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6"
          >
            Our Global Network
          </motion.h2>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-gray-600 max-w-2xl mx-auto"
          >
            From California to Dhaka, our alumni association connects members
            across the globe. Wherever you are, you’ll find a supportive alumni
            community ready to welcome you.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {chapters.map((chapter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white rounded-2xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {chapter.city}
              </h3>
              <p className="text-gray-600 text-sm">
                Members: {chapter.members}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
